import { Box, Container, Flex, Text } from '@chakra-ui/react'
import { CONTAINER_MAX_WIDTH } from '@constants/container.constant'
import Image from 'next/image'
import React from 'react'
import { useResponsive } from '@common/hooks'

interface FooterProps {
  bg?: string
  color?: string
}

const FooterCopyright: React.FC<FooterProps> = (props) => {
  const { xlMin } = useResponsive()

  const paddingX = xlMin ? 28 : 4
  const currentYear = new Date().getFullYear()

  return (
    <Box bg={props.bg ?? 'tuatara'}>
      <Container
        color={'white'}
        py={8}
        justifyContent={'space-between'}
        display="flex"
        maxW={CONTAINER_MAX_WIDTH}
        px={paddingX}
      >
        <Flex
          alignItems="end"
          justifyContent={'flex-start'}
          gap={2}
          wrap={'wrap'}
        >
          {/* Left side: JML white logo */}
          <Image
            src={'/images/logo-footer-white.png'}
            width={xlMin ? 230 : 170}
            height={xlMin ? 75 : 43}
            alt="logo-footer-white"
          />
          <Text
            textStyle="footerText"
            color={props.color ?? '#E5E4D7'}
            ml={xlMin ? '-40px' : '0'}
          >
            Copyright @ {currentYear} JML Singapore Pte Ltd, All rights
            reserved.
          </Text>
        </Flex>
        {/* Right side: beige Habbit logo */}
        <Flex alignItems="start">
          <Image
            src={'/images/footer-img.png'}
            width={xlMin ? 150 : 200}
            height={xlMin ? 80 : 100}
            alt="habbit-logo-icon"
          />
        </Flex>
      </Container>
    </Box>
  )
}

export default FooterCopyright
